import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  logoContainer: {
    position: 'relative'
  },
  poweredByLogoContainer: {
    position: 'absolute',
    [theme.breakpoints.down('sm')]: {
      left: 10
    },
    [theme.breakpoints.up('md')]: {
      left: 50
    }
  },
  lauktiLogo: {
    [theme.breakpoints.down('sm')]: {
      width: '9.25rem',
      height: '2.625rem'
    },
    [theme.breakpoints.up('md')]: {
      width: '13.063rem',
      height: '3.75rem'
    }
  },
  kickCovidLogo: {
    [theme.breakpoints.down('xs')]: {
      width: '11.25rem',
      height: '2.8rem'
    },
    [theme.breakpoints.up('sm')]: {
      width: '20rem',
      height: '3.8rem'
    }
  },
  logoInNavbarLaukti: {
    [theme.breakpoints.down('xs')]: {
      width: '5rem',
      height: '1.3rem'
    },
    [theme.breakpoints.up('sm')]: {
      width: '12.3125rem',
      height: '3.188rem'
    }
  },
  logoInNavbarKickcovid: {
    [theme.breakpoints.down('xs')]: {
      width: '6.875rem',
      height: '1.25rem'
    },
    [theme.breakpoints.up('sm')]: {
      width: '12.3125rem',
      height: '2.8rem'
    }
  },
  poweredByLogo: {
    [theme.breakpoints.down('sm')]: {
      width: '3rem',
      height: '1rem'
    },
    [theme.breakpoints.up('md')]: {
      width: '5.5625rem',
      height: '1.3rem'
    }
  }
}));

export default useStyles;
